export const FORM_FIELD_NAMES = {
    ENABLED: "enabled",
    TYPE: "affiliatePostbackSettingType"
}